import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Button, Input, Label, Card, CardBody, Modal, ModalHeader, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ContentLoader from 'react-content-loader';
import queryString from 'query-string';
import moment from 'moment';
import { getLocale } from '../transInit';
import { t } from 'ttag';
import { Localization } from 'react-widgets';
import momentLocalizer from 'react-widgets-moment';
import { useParams, useSearchParams } from 'react-router-dom';
import * as transInit from '../transInit';
import { Helmet } from 'react-helmet';
import SvgViewer from '../../../commons/SvgViewer';
import Countdown from './Countdown';
import StepperSection from './StepperSection';
import SuccessEmptyState from '../../../commons/SuccessEmptyState';
import EmptyState from '../../../commons/EmptyState';
import Services from './services';
import 'moment/locale/hu';
import { CookieConsentStateContext } from '../../../commons/CookieConsent';
import TimeFormatter from '../../../commons/TimeFormatter';
import NumberFormatter from '../../../commons/NumberFormatter';
import { useLoading } from '../LoadingContext';
import NotFound from './NotFound';

moment.locale('hu');
const localizer = new momentLocalizer(moment);
let firstload = true;
const CONSTANTS = {
  fizetesiModAzonositok: ['BAR'],
  FIZMOD_KOD_BARION: 'BAR',
  compoundIdSeparator: '_'
};

const EventSeatsPage = (props) => {
  const { toggleLoading } = useLoading();
  let momentLoc = moment();
  momentLoc.locale(transInit.getLocale());
  let body = document.body;

  if (firstload) {
    body.classList.add('dark-theme');
    firstload = false;
  }

  const [activeSectors, setActiveSectors] = useState([]);

  const [state, setState] = useState({
    modalDelete: false,
    nyugtaButtonLoading: false,
    // [1,2,3,4]
    bucket: [],
    // ['LOAD', 'DATA', 'NETW', 'TABL']
    pageStatus: 'LOAD',
    // ['CANCELED', 'SUCCEEDED']
    redirectStatus: ['SUCCEEDED'],
    isConsentSet: false,
    currentStep: 1,
    buttonLoading: false,
    formNev: '',
    formEmail: '',
    formMegvasarlas: false,
    formFoglalas: false,
    formRot: '',
    formBarion: false,
    checkboxAdatvedelmi: false,
    adatvedelmiUrl: null,
    hirlevelUrl: null,
    modalNyugta: false,
    modalNyugtaText: '',
    event: {
      ecu: '',
      eru: '',
      cid: undefined,
      des: undefined,
      eid: undefined,
      end: undefined,
      lid: undefined,
      nam: undefined,
      res: undefined,
      sta: undefined,
      otl: undefined,
      epi: '',
      eri: '',
      cur: undefined,
    },
    layout: {
      // pi3: '',
      areas: [],
      blocks: [],
      cod: undefined,
      hid: undefined,
      hna: undefined,
      lid: undefined,
      nam: undefined,
      str: {},
      texts: [],
      vad: undefined,
      vna: undefined
    },
    init: {
      sectors: [],
      now: '',
      pty: [],
      rot: []
    },
    tickets: [],
    rendeles: {
      gatewayUrl: '',
      rendeles: {
        rot: {},
      },
      rendelesadat: {
        jegyadatok: []
      }
    },
    rendelesPenznem: '',
  });

  const areaClickParams = useRef({});

  const setStepFour = useCallback((resP) => {
    if (resP && resP[0] && resP[0].Status) {
      setState({
        ...state,
        currentStep: 4,
        redirectStatus: resP[0].Status.toUpperCase()
      })
    }
  }, [])

  const getContrastYIQ = (hexcolor) => {
    hexcolor = hexcolor.replace('#', '');
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? 'darkf' : 'lightf';
  }

  const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  const loadData = () => {
    const {
      match
    } = props;
    setState({
      ...state,
      pageStatus: 'LOAD'
    })

    Services.getEvent(eventId, CONSTANTS.fizetesiModAzonositok, (err, res) => {
      if (!err) {

        window.bp('init', 'addBarionPixelId', window['barion_pixel_id']);
        setState({
          ...state,
          barionPixelLoaded: true
        });

        let initAkt = res[0].init;
        initAkt.sectors = initAkt.sectors.map(m => ({ ...m, vcaf: m.caf }));

        let paymentId = queryString.parse(search).paymentId;
        if (paymentId && paymentId !== '') {
          Services.GetPaymentState(paymentId, (errP, resP) => {
            if (!errP) {
              setState({
                ...state,
                event: res[0].event,
                layout: res[0].layout,
                init: initAkt,
                tickets: res[0].tickets,
                pageStatus: 'DATA'
              });

              setStepFour(resP)
            }
          });
        } else {
          if (res[0].tickets && res[0].tickets.length == 1) {
            setActiveSectors([res[0].tickets[0].tid]);
          }

          Services.getSzin(res[0].layout.vid, (errEvent, resEvent) => {
            if (!errEvent) {
              if (isEmptyObject(resEvent[0])) {
                toggleLoading(false);
              } else {
                if (resEvent[0].color[0] === 'VILAGOS') {
                  document.querySelector('body').classList.remove('dark-theme');
                  document.documentElement.style.setProperty("--svg-viewer-hatter-szin", "#fff");
                  document.documentElement.style.setProperty("--elsodleges-szin", "#" + resEvent[0].color[1]);
                  document.documentElement.style.setProperty("--footer-hatter", "#" + resEvent[0].color[4]);
                  document.documentElement.style.setProperty("--input-border-focus-szin", "#" + resEvent[0].color[2])
                  document.documentElement.style.setProperty("--form-control-focus-szin", "rgba(" + hexToRgb(resEvent[0].color[2]).r +
                    "," + hexToRgb(resEvent[0].color[2]).g + "," +
                    hexToRgb(resEvent[0].color[2]).b +
                    ",0.8)");
                  document.documentElement.style.setProperty("--navbar-background", "rgba(" + hexToRgb(resEvent[0].color[3]).r +
                    "," + hexToRgb(resEvent[0].color[3]).g + "," +
                    hexToRgb(resEvent[0].color[3]).b +
                    ",0.8)");
                } else {
                  document.body.style.setProperty("--elsodleges-szin", "#" + resEvent[0].color[1]);
                  document.body.style.setProperty("--footer-hatter", "#" + resEvent[0].color[4]);
                  document.body.style.setProperty("--input-border-focus-szin", "#" + resEvent[0].color[2])
                  document.body.style.setProperty("--form-control-focus-szin", "rgba(" + hexToRgb(resEvent[0].color[2]).r +
                    "," + hexToRgb(resEvent[0].color[2]).g + "," +
                    hexToRgb(resEvent[0].color[2]).b +
                    ",0.8)");
                  document.body.style.setProperty("--navbar-background", "rgba(" + hexToRgb(resEvent[0].color[3]).r +
                    "," + hexToRgb(resEvent[0].color[3]).g + "," +
                    hexToRgb(resEvent[0].color[3]).b +
                    ",0.8)");
                }

                const base64Logo = "data:image/png;base64," + resEvent[0].logo[0];

                document.getElementById("headerLogo").src = base64Logo;
                document.getElementById("navbar-brand").href = res[0].layout.vws ? res[0].layout.vws : "";

                const footer = document.getElementById('sticky-footer');
                const contrast = getContrastYIQ(resEvent[0].color[4])

                document.body.style.setProperty("--visszaszamlalo-szin", getCorrectTextColor(resEvent[0].color[1]))

                if (getContrastYIQ(resEvent[0].color[4]) === 'darkf') {
                  document.body.style.setProperty("--footer-link-color", "#3c3c3c");
                } else {
                  document.body.style.setProperty("--footer-link-color", "#dcdcdc");
                }

                footer.classList.remove("darkf-bg", "lightf-bg");
                footer.classList.add(contrast + '-bg');

                toggleLoading(false);
              }
            }
          });
          setState({
            ...state,
            tickets: res[0].tickets,
            event: res[0].event,
            layout: res[0].layout,
            init: initAkt,
            pageStatus: 'DATA'
          });
        }
      } else {
        setState({
          ...state,
          pageStatus: 'NETW'
        });

        toggleLoading(false);
      }
    });
  }

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (areaClickParams.areaid) {
      onAreaClick(areaClickParams.area);
    }
  }, [activeSectors]);

  const renderPixelConsent = (value) => {
    if (!state.isConsentSet) {
      if (value.marketing === 0) {
        window.bp('consent', 'rejectConsent');
      } else {
        window.bp('consent', 'grantConsent');
      }
      setState({
        ...state,
        isConsentSet: true
      });
    }
    return '';
  }

  const handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    switch (name) {
      case 'formMegvasarlas':
        setState({
          ...state,
          formFoglalas: false,
          formPayment: null,
          [name]: value
        });
        break;
      case 'formFoglalas':
        setState({
          ...state,
          formMegvasarlas: false,
          formPayment: null,
          [name]: value
        });
        break;
      default:
        setState({
          ...state,
          [name]: value
        });
    }
  }

  const handleRotChange = (e) => {
    const { target } = e;
    const { name } = target;

    setState({
      ...state,
      formRot: name
    });
  }

  const handleTicketQuantityChange = (e, idx, capacityFree, areaId, sectorId, offset) => {
    const { target } = e;
    let value = target.type === 'checkbox' ? target.checked : target.value;

    if (!offset && (!Number.isInteger(parseInt(value, 10)) || parseInt(value, 10) <= 0)) {
      value = 1;
    }

    let bucket = JSON.parse(JSON.stringify(state.bucket));
    let bucketIdx = bucket[idx];
    const allTicketInAreaQua = bucket.filter(x => x.aid === areaId).reduce((acc, curr) => acc + curr.qua, 0);
    const otherTicketInAreaQua = allTicketInAreaQua - bucketIdx.qua;
    const maxValue = Math.min(capacityFree, capacityFree - otherTicketInAreaQua);
    value = Math.min(value || 1, maxValue);

    const originalQua = bucketIdx.qua;

    bucketIdx.qua = Math.min(Math.max(1, offset ? parseInt(bucketIdx.qua, 10) + parseInt(offset, 10) : parseInt(value, 10)), maxValue);
    bucket[idx] = bucketIdx;

    setSectorVirtualCafArea(areaId, sectorId, bucketIdx.qua - originalQua);

    setState({
      ...state,
      bucket: bucket
    });
  }

  const setSectorVirtualCafArea = (areaId, sectorId, offset) => {
    if (!offset) {
      return;
    }

    let initAkt  = state.init;
    let sectorsAkt = initAkt.sectors.map(s => {
      s.vcaf = (s.aid === areaId && s.id === sectorId) ? Math.min(s.vcaf - offset, s.cap) : s.vcaf;

      return s;
    });

    initAkt.sectors = sectorsAkt;
    setState({ ...state, init: initAkt });
  }

  const getTicketTypeByTicketId = (ticketSector, areaId) => {
    let tickets = JSON.parse(JSON.stringify(state.tickets));
    let activeSectorsArray = JSON.parse(JSON.stringify(activeSectors));
    let result = -1;

    activeSectorsArray.forEach((activeSector) => {
      tickets.forEach((ticket) => {
        if ((activeSector === getCompoundId(areaId, ticket.tid)) && (ticket.sec === ticketSector)) {
          result = {
            sec: activeSector,
            pri: ticket.pri,
            nam: ticket.nam,
            cur: ticket.cur
          };
        }
      });
    });

    return result;
  }

  const isTicketInBucket = (tid, deletedTickets) => {
    let hasTalalat = false;
    deletedTickets.forEach((element) => {
      if (tid === element.tid) hasTalalat = true;
    });
    return hasTalalat;
  }

  const hexToRgb = (hex) => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  const onAreaClick = (clickedArea) => {
    let activeTicket = getTicketTypeByTicketId(clickedArea.sec, clickedArea.tid);

    // ha van már a kosárban adott terület+jegytípus, akkor nem csinál semmit
    if (state.bucket.some(bucketItem => bucketItem.tid === activeTicket.sec))
      return;

    if (activeTicket !== -1) {
      let layout = state.layout;
      layout.areas.forEach(a => {
        if (a.tid === clickedArea.tid) {
          a.new = true;
        }
      });

      setSectorVirtualCafArea(clickedArea.tid, clickedArea.sec, 1);

      setState({
        ...state,
        layout: layout,
        bucket: [...state.bucket,
        {
          aid: clickedArea.tid,
          lab: clickedArea.lab,
          tid: activeTicket.sec,
          pri: activeTicket.pri,
          nam: activeTicket.nam,
          cur: activeTicket.cur,
          caf: clickedArea.caf,
          qua: 1,
          sec: clickedArea.sec
        }
        ],
      });
    }
  }

  const onSeatClick = (ticket, hasGroup, rowLabel, seatPrefix, seatSufix, blockPrefix) => {
    let isDelete = false;
    let blockIdx = 0;
    let layout = JSON.parse(JSON.stringify(state.layout));
    layout.blocks.forEach((block, idx) => {
      block.seats.forEach((seat) => {
        if (seat.tid === ticket.tid) {
          if (seat.new) isDelete = true;
          blockIdx = idx;
          seat.new = !seat.new;
        }
      });
    });

    let offset = 0;
    if (hasGroup) {
      layout.blocks[blockIdx].seats.forEach((element) => {
        if (isDelete) {
          offset--;
          element.new = false;
        } else {
          offset++;
          element.new = true;
        }
      });
    } else {
      offset += isDelete ? -1 : 1;
    }

    let initAkt  = state.init;
    let isTicketTypeNotSelected = getTicketTypeByTicketId(ticket.sec) === -1;
    let sectorsAkt = initAkt.sectors.map(s => {
      s.vcaf = (!isTicketTypeNotSelected || isDelete) && (!s.aid && s.id === ticket.sec) ? Math.min(s.vcaf - offset, s.cap) : s.vcaf;

      return s;
    });

    initAkt.sectors = sectorsAkt;

    if (isDelete) {
      if (hasGroup) {
        let deletedTickets = [];
        layout.blocks.forEach((block) => {
          block.seats.forEach((seat) => {
            if (seat.tid === ticket.tid) {
              deletedTickets = block.seats;
            }
          });
        });
        let bucket = JSON.parse(JSON.stringify(state.bucket));
        let filteredBucket = bucket.filter((item, index) => {
          return !isTicketInBucket(item.sid, deletedTickets)
        });
        setState({
          ...state,
          bucket: filteredBucket,
          layout: layout,
          init: initAkt,
        });
      } else {
        setState({
          ...state,
          bucket: state.bucket.filter(bucketItem => bucketItem.sid !== ticket.tid),
          layout: layout,
          init: initAkt,
        });
      }
    } else {
      if (isTicketTypeNotSelected) {
        props.globals.addError(t`Ülőhely választáshoz jegytípus választása kötelező!`);
      } else {
        seatPrefix = seatPrefix ? seatPrefix + ' ' : '';
        seatSufix = seatSufix ? seatSufix : '';
        
        let selectedSector = state.init.sectors.find(x => !x.aid && x.id === ticket.sec);
        
        if (hasGroup) {
          let newTickets = [];
          layout.blocks.forEach(block => {
            block.seats.forEach(seat => {
              if (seat.tid === ticket.tid) {
                newTickets = block.seats;
              }
            });
          });
          let newDetailedTickets = [];
          newTickets.forEach((item) => {
            newDetailedTickets.push({
              rowLabel: rowLabel,
              lab: seatPrefix + item.lab + seatSufix,
              sid: item.tid,
              lbp: blockPrefix,
              tid: getTicketTypeByTicketId(item.sec).sec,
              pri: getTicketTypeByTicketId(item.sec).pri,
              nam: getTicketTypeByTicketId(item.sec).nam,
              cur: getTicketTypeByTicketId(item.sec).cur,
              seclab: selectedSector && ('hu' === transInit.getLocale() ? selectedSector.nam : (selectedSector.name ? selectedSector.name : selectedSector.nam)),
            })
          })
          setState({
            ...state,
            bucket: state.bucket.concat(newDetailedTickets),
            layout: layout,
            init: initAkt,
          });
        } else {
          setState({
            ...state,
            bucket: [...state.bucket,
            {
              rowLabel: rowLabel,
              lab: seatPrefix + ticket.lab + seatSufix,
              sid: ticket.tid,
              lbp: blockPrefix,
              tid: getTicketTypeByTicketId(ticket.sec).sec,
              pri: getTicketTypeByTicketId(ticket.sec).pri,
              nam: getTicketTypeByTicketId(ticket.sec).nam,
              cur: getTicketTypeByTicketId(ticket.sec).cur,
              seclab: selectedSector && ('hu' === transInit.getLocale() ? selectedSector.nam : (selectedSector.name ? selectedSector.name : selectedSector.nam)),
            }
            ],
            layout: layout,
            init: initAkt,
          });
        }
      }
    }
  }

  const renderSectors = () => {
    const {
      init,
    } = state;

    const sectors = init.sectors.map((item, idx) => {
      return item.use && (
        <React.Fragment key={idx}>
          <div className="col-md-12 mb-1" style={{ padding: 0, color: item.caf === 0 ? '#6e6e6e' : undefined }}>
            <p style={{
              borderLeft: '8px solid #' + (item.caf === 0 ? '6e6e6e' : item.col),
              padding: 4,
              paddingLeft: 10,
              margin: 0
            }}><span>{('hu' === transInit.getLocale() ? item.nam : (item.name ? item.name : item.nam)) + ' ('}</span>
              <span>{t`szabad/összes`}{' - ' + item.vcaf + '/' + item.cap + '): '}</span>
            </p>
          </div>
          {renderTicketsByIDd(item.id, item.aid, item.col, item.han, item.caf, idx)}
        </React.Fragment>
      );
    });

    return sectors;
  }

  const renderPaymentTypes = () => {
    if (state.init && state.init.fizmod) {
      return (
        <React.Fragment>
          <p style={{ fontSize: '1.65rem' }}>{t`Fizetési mód megadása:`}</p>
          <div className="row">
            {renderPaymentTypeInputs()}
          </div>
          <p>* = {t`A mezők kitöltése kötelező`}</p>
        </React.Fragment>
      );
    }

    return <p>{t`Nincs választható fizetési mód!`}</p>;
  }

  const getConvenienceFeeString = (cop, cof, cur) => {
    let dij = cop ? (NumberFormatter.addSpacesToString(cop, NumberFormatter.OSSZEG) + '%') : '';
    dij += cop && cof ? ' + ' : '';
    dij += cof ? NumberFormatter.addSpacesToString(cof, NumberFormatter.OSSZEG) + ' ' + cur : '';

    return dij.replace('.', ',');
  }

  const renderConvenienceFee = (item) => {
    if (!item.useconveniencefee || (!state.event.cof && !state.event.cop))
      return;

    let dij = getConvenienceFeeString(state.event.cop, state.event.cof, state.event.cur);

    if (getLocale() === 'en' && item.conveniencefeedescriptionen) {
      return (
        <div>
          <br />
          {item.conveniencefeedescriptionen.replace('$1', dij.trim())}
        </div>
      );
    } else if (item.conveniencefeedescription) {
      return (
        <div>
          <br />
          {item.conveniencefeedescription.replace('$1', dij.trim())}
        </div>
      );
    }
  }

  const renderPaymentTypeInputs = () => {
    return state.init.fizmod.map((fizmod) => {
      let formName = 'formPayment' + fizmod.kod;
      return (
        <div className="col-md-6" style={{}}>
          <input
            name="formPayment"
            type="radio"
            id={formName}
            checked={parseInt(state.formPayment, 10) === fizmod.id}
            onChange={handleInputChange}
            value={fizmod.id}
          />
          <label htmlFor={formName}>{fizmod.nev}</label>
          <img src={process.env.PUBLIC_URL + '/img/' + fizmod.kod + '.png'} alt={fizmod.nev + ' logo'} />
          <br />
        </div>
      );
    });
  }


  const isNotEmpty = (data) => {
    if (data && data !== '') return true;
    return false;
  }

  const getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  }

  const getCompoundId = (...elements) => {
    return elements.filter(x => x !== undefined && x !== null).join(CONSTANTS.compoundIdSeparator);
  };

  const extractTicketIdFromCompoundId = (compoundId) => {
    if (compoundId && compoundId.indexOf(CONSTANTS.compoundIdSeparator) > -1) {
      let sectorId = compoundId.substr(compoundId.indexOf(CONSTANTS.compoundIdSeparator) + 1)

      return sectorId;
    }

    return compoundId;
  }

  const SORT_PATTERN = /\d+/g;

  const zeroPadding = (item) => item.replace(SORT_PATTERN, m => m.padStart(10, '0'));

  const renderTicketsByIDd = (sectorId, areaId, sectorColor, isAccessible, capacityFree, sectorIdx) => {
    const {
      tickets,
      layout,
      bucket
    } = state;

    let ticketsToRender = tickets.filter(t => t.sec === sectorId).sort((a, b) => zeroPadding(a.nam).localeCompare(zeroPadding(b.nam)));

    const ticket = ticketsToRender.map((item, idx) => {
      const compoundId = getCompoundId(areaId, item.tid);
      if (!activeSectors.includes(compoundId)) {
        let newActiveSectors = JSON.parse(JSON.stringify(activeSectors));
        newActiveSectors[sectorIdx] = compoundId;
      }
      return (
        <React.Fragment key={idx}>
          <div className="col-md-4 col-sm-6 px-sm-1" key={compoundId} id="kartyatipuscard">
            <Card
              style={{
                backgroundColor: activeSectors.includes(compoundId) ? '#' + sectorColor : null,
                color: activeSectors.includes(compoundId) ? getCorrectTextColor(sectorColor) : null,
                cursor: capacityFree === 0 ? 'not-allowed' : 'pointer',
                marginTop: 0,
                marginBottom: 4
              }}
              onClick={() => {
                if (capacityFree !== 0) {
                  const active = JSON.parse(JSON.stringify(activeSectors));
                  const qua = bucket.filter(x => x.aid === areaId).reduce((acc, curr) => acc + curr.qua, 0);

                  if (active.includes(compoundId) || qua === capacityFree) {
                    return;
                  }

                  let newActiveSectors = [];
                  newActiveSectors.push(compoundId);

                  areaClickParams.areaid = areaId;
                  areaClickParams.area = areaId ? layout.areas.find(x => x.tid === areaId) : null;

                  setActiveSectors(newActiveSectors);
                }
              }}
            >
              <CardBody className='align-items-center row' style={{ paddingTop: 2, paddingBottom: 2 }}>
                <div className='col-8 mb-0 pr-0' style={{ textAlign: 'left' }}>
                  {item.nam + ' '}
                  {isAccessible && <i className="fa fa-wheelchair" aria-hidden="true" />}
                  {isNotEmpty(item.des) && (<i className="fa fa-info-circle pull-right" style={{ marginTop: 4 }} aria-hidden="true" id={'tickedcard-' + compoundId} />)}
                </div>
                <div className='col-4' style={{ textAlign: 'end' }}>{NumberFormatter.formatterSpaceOsszegPenznem(item.pri, null, item.cur)}</div>
              </CardBody>
            </Card>
            {isNotEmpty(item.des) && (
              <UncontrolledTooltip trigger='hover focus-visible' placement="top" target={'tickedcard-' + compoundId}>
                {item.des}
              </UncontrolledTooltip>
            )}
          </div>
        </React.Fragment>
      )
    });

    return ticket;
  }

  const isEmptyOrNull = (data) => {
    if (!data || data === '') return true;
    return false;
  }

  const getPurchaseObj = () => {
    return {
      ste: state.currentStep,
      now: state.init.now,
      eid: state.event.eid,
      rid: state.event.rid,
      nam: state.formNev,
      ema: state.formEmail,
      areatickets: state.bucket.filter(x => x.aid).map(x => ({ ...x, tid: extractTicketIdFromCompoundId(x.tid) })),
      seattickets: state.bucket.filter(x => x.sid),
      rot: (!state.formRot || state.formRot === '') ? null : state.formRot,
      pty: (state.formRot === 'ONLINE_VASARLAS') ? parseInt(state.formPayment, 10) : null,
      cns: !state.adatvedelmiUrl || state.checkboxAdatvedelmi,
      fizmodok: CONSTANTS.fizetesiModAzonositok,
    };
  }

  const toggleNyugtaModal = () => {
    setState({ ...state, modalNyugta: !state.modalNyugta, modalNyugtaText: '' });
  }

  const goToStepFive = useCallback(() => {
    if (currentStep === 4 && state.buttonLoading === false) {
      setTimeout(() => {
        if (!isEmptyOrNull(state.event.eru)) {
          window.location.replace(state.event.eru);
        }
      }, 7000);
    }
  }, [state.currentStep, state.buttonLoading])

  const rendelesFolytatas = () => {
    Services.sendPurchase(getPurchaseObj(), (err, res) => {
      if (!err) {
        if (state.formRot === 'ONLINE_VASARLAS' && state.formPayment) {
          let valasztottFizMod = state.init.fizmod.find(fizmod => fizmod.id === parseInt(state.formPayment, 10));

          // BARION ÁG
          if (valasztottFizMod && (valasztottFizMod.kod === CONSTANTS.FIZMOD_KOD_BARION)) {
            if ('fbq' in window) {
              window.fbq('track', 'Purchase', { currency: state.rendelesPenznem, value: state.bucket.reduce((a, o) => (a + o.pri), 0) });
            }
            window.location.replace(res[0].gatewayUrl);
          }
          // IDE JÖN A TÖBBI ÚJ FIZETÉSI ÁG IMPLEMENTÁCIÓ
          // ...
        } else {
          setState({
            ...state,
            buttonLoading: false,
            currentStep: 5
          });
          goToStepFive();
          if ('fbq' in window) {
            window.fbq('track', 'AddToWishlist');
          }
        }
      } else {
        setState({ ...state, buttonLoading: false });
      }
    });
  }

  const sumbitNyugtaWarning = () => {
    setState({
      ...state,
      nyugtaButtonLoading: true,
      modalNyugtaText: '',
    });
    toggleNyugtaModal();
    rendelesFolytatas();
    setState({
      ...state,
      nyugtaButtonLoading: false
    });
  }

  const {
    currentStep,
    bucket,
    event,
    layout,
    init,
    formRot,
  } = state;

  moment.locale(transInit.getLocale());
  const { eventId } = useParams();
  const search = useSearchParams();
  return (
    <React.Fragment>
      <Localization date={localizer}>
        {state.event && (
          <Helmet>
            <title>{state.event.nam}</title>
            <meta name="description" content={state.event.des} />
            <meta name="title" content={state.event.nam} />
          </Helmet>
        )
        }
        {state.pageStatus === 'NETW' && (
          <NotFound />
        )}
        {state.pageStatus !== 'NETW' && (
          <CookieConsentStateContext.Consumer key={'key'}>
            {value => (
              <div className="landing__section">
                <div className="container">
                  <div className="expanded__inner" style={{}}>
                    <h2 className="expanded__title subtitle">{t`JEGYVÁSÁRLÁS`}</h2>
                  </div>
                  <div className="container" style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <div className="row justify-content-md-center">
                      <Countdown time={event.otl} eru={event.eru} rid={event.rid} eventId={eventId} />
                      <div className="col-md-3 d-none d-md-block">
                        {{
                          LOAD: (
                            <ContentLoader
                              key={1}
                              height={500}
                              width={900}
                              speed={1}
                              backgroundColor="#353535"
                              foregroundColor="#404040"
                            >
                              <rect x="20" y="15" rx="20" ry="20" width="300" height="450" />
                            </ContentLoader>
                          ),
                          DATA: (
                            (!isEmptyOrNull(state.event.ecu) && !isEmptyOrNull(state.event.eru)) && (
                              <img
                                // src={state.event.eru + state.event.ecu}  
                                src={state.event.eru + '/api/helyszin/public' +  state.event.ecu} // ez nem lehet felcommitálni!!! csak local működik - mg
                                alt="poster"
                                className="img-fluid"
                                style={{ width: '100%' }}
                              />
                            )
                          ),
                          NETW: (<span />),
                        }[state.pageStatus]}
                      </div>
                      <div className="col-md-9">
                        {{
                          LOAD: (
                            <ContentLoader
                            key={2}  
                            height={500}
                              width={1300}
                              speed={1}
                              backgroundColor="#353535"
                              foregroundColor="#404040"
                            >
                              <rect x="20" y="17" rx="10" ry="10" width="840" height="66" />
                              <rect x="20" y="150" rx="10" ry="10" width="500" height="50" />
                              <rect x="20" y="250" rx="10" ry="10" width="500" height="50" />
                              <rect x="20" y="350" rx="10" ry="10" width="500" height="50" />
                            </ContentLoader>
                          ),
                          DATA: (
                            <React.Fragment>
                              <h3 style={{ marginBottom: 18 }}>{event.nam}</h3>
                              <p style={{ color: '#a09696', fontSize: 18 }}>{layout.hna}</p>
                              <p><b>{t`Helyszín:`} </b> {layout.vna}{' '}{layout.vad}</p>
                              <p><b>{t`Időpont:`} </b> {event.sta && TimeFormatter.formatLLLL(event.sta)} </p>
                              <p><b>{t`Leírás:`} </b> {event.des} </p>
                            </React.Fragment>
                          ),
                          NETW: (<span />),
                        }[state.pageStatus]}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="landing__section" style={{ marginTop: 0 }}>
                  <div className="container">
                    <div>
                      <StepperSection currentStep={currentStep}>
                        {{
                          1: (
                            <React.Fragment>
                              <div className="wrapper tickettype mb-0 mb-sm-1 pb-0 pb-sm-1" style={{ padding: 20 }}>
                                <p className="tickettype-card-title">{t`Jegytípus választása:`}</p>
                                <p>{t`Jegyvásárláshoz, illetve foglaláshoz kérjük, először válassza ki a jegy típusát!`}</p>
                                <div className="row justify-content-center no-gutters" style={{ margin: 0, marginBottom: 4 }}>
                                  {renderSectors()}
                                </div>
                              </div>
                              <SvgViewer
                                pinch
                                zoomEnabled
                                data={layout}
                                szektorok={init.sectors}
                                szinek={{
                                  coa: init.coa,
                                  con: init.con,
                                  cop: init.cop
                                }}
                                onSeatClick={onSeatClick}
                                onAreaClick={onAreaClick}
                                style={{ maxHeight: 320 }}
                                isPublic
                              />
                              <div className="wrapper mt-0" style={{ padding: 20 }}>
                                <p style={{ fontSize: '1.2rem', marginBottom: 5 }}>{t`Választott jegyek:`}</p>
                                <div className="row no-gutters">
                                  {bucket.length > 0 ? bucket.map((item, index) => {
                                    return (
                                      <div className="select-ticket" key={index}>
                                        <div className="row" style={{ margin: 0 }}>
                                        {item.sid &&
                                          <React.Fragment>
                                            <div className="col-md-11 d-flex align-items-center" style={{ paddingRight: 0 }}>
                                              <span>{item.seclab + ' | '
                                                + [item.lbp, item.rowLabel, item.lab].join(' ') + ' | '
                                                + item.nam + ' | '
                                                + NumberFormatter.formatterSpaceOsszegPenznem(item.pri, null, item.cur)}</span>
                                            </div>
                                            <div className="col-md-1" style={{ padding: 0 }}>
                                              <div className="d-flex float-right">
                                                <Button
                                                  className="search-button-style-small text-correct-button icon-trash"
                                                  id={'ticket-' + index.toString() + '-torles'}
                                                  style={{ marginBottom: 0 }}
                                                  onClick={() => {
                                                    layout.blocks.forEach((block) => {
                                                      block.seats.forEach((seat) => {
                                                        if (seat.tid === bucket[index].sid) {
                                                          onSeatClick({ tid: seat.tid, sec: seat.sec }, block.bsa);
                                                          setActiveSectors([]);
                                                        }
                                                      });
                                                    });
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </React.Fragment>
                                        }
                                        {item.aid &&
                                          <React.Fragment>
                                            <div className="col-md-8 d-flex align-items-center" style={{ paddingRight: 0, marginBottom: '5px' }}>
                                              <span>{item.lab + ' | ' + item.nam + ' | ' + NumberFormatter.formatterSpaceOsszegPenznem(item.pri, null, item.cur)}</span>
                                            </div>
                                            <div className="col-md-4" style={{ padding: 0 }}>
                                              <RFForm id="form-quantity" style={{ margin: 0 }}>
                                                <div className="d-flex float-right">
                                                  <Button
                                                    className="search-button-style-small text-correct-button"
                                                    id={'ticket-' + index + '-minus'}
                                                    style={{ marginBottom: 0}}
                                                    type="button"
                                                    disabled={state.buttonLoading}
                                                    onClick={(e) => handleTicketQuantityChange(e, index, item.caf, item.aid, item.sec, -1)}
                                                  >
                                                    <i className="fa fa-minus" aria-hidden="true" />
                                                  </Button>
                                                  <RFField
                                                    name="ticketQuantity"
                                                    id={'ticket-' + index + '-quantity'}
                                                    style={{ textAlign: 'center', width: '90px', marginBottom: 0, marginLeft: '8px', marginRight: '8px', padding: '2px 0px 2px 0px' }}
                                                    numberOnlyWhole
                                                    forcedValue={item.qua}
                                                    autoComplete="off"
                                                    onChange={(e) => handleTicketQuantityChange(e, index, item.caf, item.aid, item.sec)}
                                                    required
                                                    onFocus={(e) => {e.target.select()}}
                                                    onClick={(e) => {e.target.select()}}
                                                  />
                                                  <Button
                                                    className="search-button-style-small text-correct-button"
                                                    id={'ticket-' + index + '-plus'}
                                                    style={{marginBottom: 0 }}
                                                    type="button"
                                                    disabled={state.buttonLoading}
                                                    onClick={(e) => handleTicketQuantityChange(e, index, item.caf, item.aid, item.sec, 1)}
                                                  >
                                                    <i className="fa fa-plus" aria-hidden="true" />
                                                  </Button>
                                                  <Button
                                                    className="search-button-style-small text-correct-button icon-trash"
                                                    id={'ticket-' + index + '-del'}
                                                    style={{ marginLeft: '20px', marginBottom: 0 }}
                                                    onClick={() => {
                                                      let bucket = state.bucket;
                                                      setSectorVirtualCafArea(bucket[index].aid, bucket[index].sec, -bucket[index].qua);

                                                      bucket.splice(index, 1);

                                                      let layoutAkt = state.layout;
                                                      layoutAkt.areas.forEach(a => {
                                                        a.new = bucket.filter(b => b.aid === a.tid).length > 0;
                                                      });

                                                      setState({
                                                        ...state,
                                                        bucket: bucket,
                                                        layout: layoutAkt,
                                                      });
                                                      setActiveSectors([]);
                                                    }}
                                                    />
                                                </div>
                                              </RFForm>
                                            </div>
                                          </React.Fragment>
                                        }
                                        </div>
                                      </div>
                                    )
                                  }) : <EmptyState hasImage title={t`Még nem választott jegyet!`} subtitle={t`Jegyválasztáshoz először válasszon jegytípust.`} />}
                                </div>
                              </div>
                            </React.Fragment>
                          ),
                          2: (
                            <div className="wrapper" style={{ padding: 20 }}>
                              <p style={{ fontSize: '1.65rem' }}>{t`Személyes adatok megadása:`}</p>
                              <RFForm id="my-form">
                                <div>
                                  <Label for="formNev">{t`Név: *`}</Label>
                                  <RFField name="formNev" id="formNev" value={state.formNev} autoComplete="off" onChange={handleInputChange} required />
                                </div>
                                <div>
                                  <Label for="formEmail">E-mail: *</Label>
                                  <RFField name="formEmail" id="formEmail" value={state.formEmail} autoComplete="off" onChange={handleInputChange} required />
                                </div>
                              </RFForm>
                              <p>* = {t`A mezők kitöltése kötelező`}</p>
                            </div>
                          ),
                          3: (
                            <div className="wrapper" style={{ padding: 20 }}>
                              <p style={{ fontSize: '1.65rem' }}>{t`Rendelés típusa:`}</p>
                              <RFForm id="my-form2">
                                <div className="row justify-content-center" style={{ margin: 0 }}>
                                  {state.init.rot.map((item, idx) => {
                                    return (
                                      <div className="col-md-6" key={idx}>
                                        <label htmlFor={item.name} id="rendelestipus-radio-label">
                                          <div
                                            style={{
                                              border: '1px solid #bbbaba',
                                              marginTop: 6,
                                              marginBottom: 6,
                                              padding: 10
                                            }}
                                          >
                                            <Input
                                              key={item.name}
                                              name={item.name}
                                              type="radio"
                                              id={item.name}
                                              checked={formRot === item.name}
                                              onChange={handleRotChange}
                                            />
                                            <div style={{ marginBottom: 20 }} id='post-rendelestipus-radio-div'>
                                              {getLocale() === 'en' ? item.publiccaptionen : item.publiccaption}
                                            </div>
                                            <br />
                                            {getLocale() === 'en' ? item.descriptionen : item.description}
                                            <br />
                                            {renderConvenienceFee(item)}
                                          </div>
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div>
                              </RFForm>
                              {formRot === 'ONLINE_VASARLAS' && renderPaymentTypes()}
                            </div>
                          ),
                          4: (
                            <div className="wrapper" style={{ padding: 20 }}>
                              <p style={{ fontSize: '1.65rem' }}>{t`Áttekintés és véglegesítés:`}</p>
                              <p style={{ fontSize: '1.4rem' }}>{t`Rendelés adatai:`}</p>
                              <div className="container">
                                <p><strong>{t`Rendelésszám: `}</strong>{state.rendeles.rendelesadat.rendelesSorszam}</p>
                                <p><strong>{t`Rendelő neve: `}</strong>{state.rendeles.rendelesadat.rendeloNev}</p>
                                <p><strong>{t`Rendelő e-mail címe: `}</strong>{state.rendeles.rendelesadat.rendeloEmail}</p>
                                <div className="row">
                                  <div id="no-more-tables" style={{ width: '100%' }}>
                                    <table className="col-sm-12 table-reservation table-striped table-condensed cf">
                                      <thead className="cf">
                                        <tr>
                                          <th>{t`Jegytípus`}</th>
                                          <th style={{ textAlign: 'right' }}>{t`Ár`}</th>
                                          {state.rendeles.rendeles.rot.useconveniencefee && ((state.event.cof != null && state.event.cof !== 0) || (state.event.cop != null && state.event.cop !== 0)) && (
                                            <th style={{ textAlign: 'right' }}>{t`Kényelmi díj`}</th>)}
                                          <th style={{ paddingLeft: '40px' }}>{t`Hely`}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {state.rendeles.rendelesadat.jegyadatok.map((item) => {
                                          let ticket = state.tickets.find(x => item.szektorId === x.sec && item.jegyTipusId === x.tid);
                                          return (
                                            <tr key={item.helyId}>
                                              <td data-title={t`Jegytípus`}>{item.jegyTipus}</td>
                                              <td data-title={t`Ár`} style={{ textAlign: 'right' }}>
                                                {NumberFormatter.formatterSpaceOsszegPenznem(ticket.pri, null, item.jegyPenznem)}
                                              </td>
                                              {state.rendeles.rendeles.rot.useconveniencefee && ((state.event.cof != null && state.event.cof !== 0) || (state.event.cop != null && state.event.cop !== 0)) && (
                                                <React.Fragment>
                                                  <td data-title={t`Kényelmi díj`} style={{ textAlign: 'right' }}>
                                                    {NumberFormatter.formatterSpaceOsszegPenznem(item.kenyelmiDij, null, item.jegyPenznem)}
                                                    {state.event.cop && <i className="fa fa-info-circle" style={{ marginTop: 4, paddingLeft: 10 }} aria-hidden="true" id={'conveniencefee-' + item.id} />}
                                                  </td>
                                                  {state.event.cop &&
                                                    <UncontrolledTooltip trigger='hover focus-visible' placement="top" target={'conveniencefee-' + item.id}>
                                                      {getConvenienceFeeString(state.event.cop, state.event.cof, item.jegyPenznem)}
                                                    </UncontrolledTooltip>
                                                  }
                                                </React.Fragment>
                                              )}
                                              <td data-title={t`Hely`} style={{ paddingLeft: '40px' }}>{item.jegyHely}</td>
                                            </tr>
                                          );
                                        })
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <p style={{ fontSize: 18 }}>{t`Összesen (X db) fizetendő: `.replace('X', state.rendeles.rendelesadat.jegyadatok.length)}<strong>
                                  {NumberFormatter.formatterSpaceOsszegPenznem(state.rendeles.rendelesadat.rendelesOsszeg, null, state.rendeles.rendelesadat.rendelesOsszegPenznem)}
                                </strong></p>
                              </div>
                            </div>
                          ),
                          5: (
                            <div className="wrapper" style={{ padding: 20 }}>
                              <p style={{ fontSize: '1.65rem' }}>{t`Sikeres foglalás!`}</p>
                              {{
                                CANCELED: (
                                  <SuccessEmptyState title="Sikertelen vásárlás" subtitle=":(" />
                                ),
                                SUCCEEDED: (
                                  <div className="empty-state animated fadeIn">
                                    <img
                                      src={process.env.PUBLIC_URL + '/img/mail-sent.svg'}
                                      className="img-fluid"
                                      alt="img-avatar"
                                    />
                                    <h3>{t`Sikeres megrendelés!`}</h3>
                                    <p>{t`Az emailt elküldtük az Ön által megadott címre.`}</p>
                                    <p>{t`Rövidesen át lesz irányítva a főoldalra!`}</p>
                                  </div>
                                ),
                              }[state.redirectStatus]}
                            </div>
                          )
                        }[currentStep]}
                      </StepperSection>
                    </div>
                    {currentStep === 2
                      ? (
                        <div className="container">
                          <div className="row float-right">
                            <div className="col-md-12" style={{ marginBottom: 16, zIndex: 100 }}>
                              {state.adatvedelmiUrl ? (
                                <RFForm>
                                  <RFField
                                    type="checkbox"
                                    id="checkboxAdatvedelmi"
                                    name="checkboxAdatvedelmi"
                                    value={state.checkAdatvedelmi}
                                    onChange={handleInputChange}
                                    styleCheckbox={{ marginTop: 5 }}
                                  />
                                  <div style={{ marginLeft: 22 }}>{t`Elolvastam és elfogadom az `} <a target="_blank" href={state.adatvedelmiUrl}>{t`Adatvédelmi és jogi nyilatkozatot`} </a></div>
                                </RFForm>
                              ) : <div />}
                            </div>
                          </div>
                          {state.hirlevelUrl ? (
                            <div className="row float-right col-md-12" style={{ marginBottom: 26, zIndex: 100, "fontWeight": "bold" }}>
                              <a target="_blank" href={state.hirlevelUrl}>{t`Feliratkozás hirlevélre`} </a>
                            </div>
                          ) : <div />}
                        </div>
                      ) : <div />
                    }
                  </div>
                </div>
                <div className="container">
                  <div className="row" style={{ margin: 0 }}>
                    <div className="col-md-12" style={{ padding: 0, marginBottom: 16 }}>
                      {currentStep < 5 && (
                        <button
                          type="button"
                          className="search-button-style btn btn-secondary text-correct-button float-right"
                          disabled={state.buttonLoading}
                          onClick={() => {

                            switch (state.currentStep) {
                              case 1:
                                setState({ ...state, buttonLoading: true });
                                Services.sendPurchase(getPurchaseObj(), (err, res) => {
                                  if (!err) {
                                    let event1 = JSON.parse(JSON.stringify(state.event));
                                    event1.rid = res[0].rendeles.rid;

                                    bucket.forEach(bucketItem => {
                                      if (bucketItem.aid) {
                                        let area = res[0].rendeles.areatickets.find(x => bucketItem.aid === x.aid && extractTicketIdFromCompoundId(bucketItem.tid) === x.tid);
                                        bucketItem.rid = area && area.rid
                                        bucketItem.id = area && area.id;
                                      } else if (bucketItem.sid) {
                                        let seat = res[0].rendeles.seattickets.find(x => bucketItem.sid === x.sid && bucketItem.tid === x.tid);
                                        bucketItem.rid = seat && seat.rid
                                        bucketItem.id = seat && seat.id;
                                      }
                                    });

                                    setState({
                                      ...state,
                                      adatvedelmiUrl: res[0].adatvedelmiurl,
                                      hirlevelUrl: res[0].hirlevelurl,
                                      event: event1,
                                      buttonLoading: false,
                                      currentStep: 2
                                    });
                                  } else {
                                    setState({ ...state, buttonLoading: false });
                                  }
                                });
                                break;
                              case 2:
                                setState({ ...state, buttonLoading: true });
                                Services.sendPurchase(getPurchaseObj(), (err, res) => {
                                  if (!err) {
                                    setState({
                                      ...state,
                                      buttonLoading: false,
                                      currentStep: 3
                                    });
                                  } else {
                                    setState({ ...state, buttonLoading: false });
                                  }
                                });
                                break;
                              case 3:
                                setState({ ...state, buttonLoading: true });
                                Services.sendPurchase(getPurchaseObj(), (err, res) => {
                                  if (!err) {
                                    setState({
                                      ...state,
                                      rendeles: res[0],
                                      buttonLoading: false,
                                      currentStep: 4,
                                      rendelesPenznem: res[0].rendelesadat && res[0].rendelesadat.rendelesOsszegPenznem
                                    });
                                  } else {
                                    setState({ ...state, buttonLoading: false });
                                  }
                                });
                                break;
                              case 4:
                                setState({ ...state, buttonLoading: true });
                                if (state.formRot === 'ONLINE_VASARLAS') {
                                  Services.checkNyugtaBizonylatAndLimit(state.event.rid, (err, res) => {
                                    if (!err) {
                                      if (res[0] && (res[0].hiba === 'ceg' || res[0].hiba === 'bizonylat' || res[0].hiba === 'limit')) { // ceg || bizonylat || limit
                                        setState({ ...state, buttonLoading: false, modalNyugta: true, modalNyugtaText: res[0].hiba });
                                      } else {
                                        rendelesFolytatas();
                                      }
                                    } else {
                                      setState({ ...state, buttonLoading: false });
                                    }
                                  });
                                } else {
                                  rendelesFolytatas();
                                }
                                break;

                              default:
                                break;
                            }
                          }}
                        >
                          {state.currentStep === 4 ? (state.formRot === 'ONLINE_FOGLALAS' ? t`Lefoglalás ` : t`Tovább a fizetéshez`) : t`Tovább `}
                          {state.buttonLoading && (
                            <div className="spinner-border spinner-border-sm" role="status" style={{ marginBottom: 2, marginLeft: 5 }}>
                              <span className="sr-only">Loading...</span>
                            </div>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                {(state.barionPixelLoaded) && (
                  <React.Fragment>
                    {renderPixelConsent(value)}
                    <img height="1" width="1" style={{ display: 'none' }} alt="Barion Pixel" src={'https://pixel.barion.com/a.gif?ba_pixel_id=' + window['barion_pixel_id'] + '&ev=contentView&noscript=1'} />
                  </React.Fragment>
                )}
              </div>
            )}
          </CookieConsentStateContext.Consumer>
        )}
        <Modal
          isOpen={state.modalNyugta}
          toggle={toggleNyugtaModal}
          backdrop="static"
          style={{
            borderRadius: '12px',
            boxShadow: 'unset',
            borderTop: '4px solid var(--elsodleges-szin)',
            background: 'var(--szurke-tartalom-hatter-szin)',
            color: 'var(--default-font-szin)'
          }}
          contentClassName="nyugtaModalContentClass"
        >
          <ModalHeader style={{
            background: 'var(--szurke-tartalom-hatter-szin)',
            color: 'var(--default-font-szin)',
            textAlign: 'center',
            borderRadius: '10px 10px 0px 0px'
          }}
          >
            {state.modalNyugtaText === 'limit' &&
              <p style={{ background: 'var(--szurke-tartalom-hatter-szin)', color: 'var(--default-font-szin)', fontSize: '1.65rem' }}>{t`Figyelmeztetés`}</p>
            }
            <p style={{ background: 'var(--szurke-tartalom-hatter-szin)', color: 'var(--default-font-szin)' }}>
              {state.modalNyugtaText === 'limit' && t`A vásárlásról az összeg miatt nyugta nem állítható ki, az erről szóló számlát kérje a szolgáltatótól!`}
              {(state.modalNyugtaText === 'ceg' || state.modalNyugtaText === 'bizonylat') && t`Fizetés nem kezdeményezhető, kérjük vegye fel a kapcsolatot a szolgáltatóval!`}
            </p>
          </ModalHeader>
          <ModalFooter
            style={{
              background: 'var(--szurke-tartalom-hatter-szin)',
              color: 'var(--default-font-szin)'
            }}
          >
            {state.modalNyugtaText === 'limit' &&
              <React.Fragment>
                <button
                  type="button"
                  className="search-button-style btn btn-secondary float-right"
                  disabled={state.nyugtaButtonLoading}
                  onClick={sumbitNyugtaWarning}>{t`Tovább a fizetéshez`}
                  {state.nyugtaButtonLoading && (
                    <div className="spinner-border spinner-border-sm" role="status" style={{ marginBottom: 2, marginLeft: 5 }}>
                      <span className="sr-only">Loading...</span>
                    </div>
                  )}
                </button>
                <button type="button" className="search-button-style btn btn-secondary float-right" disabled={state.nyugtaButtonLoading} onClick={toggleNyugtaModal}>{t`Mégsem`}</button>
              </React.Fragment>
            }
            {(state.modalNyugtaText === 'ceg' || state.modalNyugtaText === 'bizonylat') &&
              <button type="button" className="search-button-style btn btn-secondary float-right" disabled={state.nyugtaButtonLoading} onClick={toggleNyugtaModal}>{t`Bezárás`}</button>
            }
          </ModalFooter>
        </Modal>
      </Localization>
    </React.Fragment>
  );
}

export default EventSeatsPage;